import React, { SyntheticEvent } from 'react';
import { Link } from 'react-router-dom';
import COPY from './copy';

import { switchAndSave } from '../../helpers';
import { Packages } from '~shared/constants/pricing';
import { usePricingState } from '~shared/hooks/usePricingState';

export default function IncludedLink({ packageName }: Readonly<{ packageName: Packages }>): React.ReactElement {
  const { dispatch } = usePricingState();

  const copy =
    packageName === Packages.AdvantageMonthly
      ? COPY.BUSINESS_PLANS_LINK_MONTHLY.defaultMessage
      : COPY.BUSINESS_PLANS_LINK.defaultMessage;
  const isAdvantagePackage = [Packages.AdvantageAnnual, Packages.AdvantageMonthly, Packages.TeamAdvantage].includes(
    packageName
  );
  const isPremierPackage = [Packages.PremierAnnual, Packages.TeamPremier].includes(packageName);

  const handleClick = (event: SyntheticEvent): void => {
    event.preventDefault();
    switchAndSave('3', isAdvantagePackage, isPremierPackage, dispatch, packageName);
  };

  return (
    <Link to="/pricing/details" onClick={handleClick}>
      {copy}
    </Link>
  );
}
